import React, {useEffect, useState} from 'react';
import { motion } from 'framer-motion';
import { ExtinctionVideoData, ItemsData } from './feactures/dataProvider';
import { InventoryHero } from '../pages/Inventory';


export const Hero = ({dataHero, userData, action}) => {
    const [hero, setHero] = useState({
        ownHero: dataHero.ownHero,
        visual: '',
    })
    const [selectHero, setSelectHero] = useState(false);
    

    useEffect(() => {
        if(dataHero.ownHero){

            loadHero(dataHero.hero_templat_id);
        }

      return () => {
        setHero({
        ownHero: dataHero.ownHero,
        visual: '',
        })
      }
    }, [dataHero])

    const loadHero = (templateTarget) => {
        if(templateTarget !== undefined){
            const data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateTarget));

            setHero((state) => ({
                ...state,
                visual: data.img,
            }))
        }
    }

    const selectHeroToggler = () => setSelectHero(!selectHero);
    
    if(selectHero){
        return(
            <InventoryHero userData={userData} closer={selectHeroToggler} action={action}/>
        )
    }
    
    if(!hero.ownHero){
        return(
            <div className='container_btn_hero'>
                <div className='boton_hero_box'>
                    <button onClick={() => selectHeroToggler()}>Select Hero</button>
                </div>
            </div>
        )
    }


  return (
    <div className='video_pj_container'>
        <motion.video src={hero.visual} muted autoPlay loop 
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 1, delay: 0.5}}
        />
        <span className='difuser_visual_pj'></span>
    </div>
  )
}
